/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:46:11
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-10-02 10:51:35
 */
import Market from './Market';

// TODO: config
export interface IGameConfig {
  version: string;
  config: any;
}

// TODO: games
export interface IGameInstallList {
  games: any[];
}

const GameMan19 = {
  // 更新端游配置给客户端
  UpdateGameConfig({ version, config }: IGameConfig): Promise<{}> {
    return Market.__asyncCallApi('GameMan19.UpdateGameConfig', { version: version.toString(), config });
  },
  // 获取端游已安装列表
  async GetGameInstallList(): Promise<any[]> {
    const res = await Market.__asyncCallApi('GameMan19.GetGameInstallList', {});
    return res.games;
  },
  // 扫描更新端游
  RefreshAndGetGameInstallList(): Promise<IGameInstallList> {
    return Market.__asyncCallApi('GameMan19.RefreshAndGetGameInstallList', {});
  },
  // 安装端游
  // TODO: webParam
  InstallGame(id: string, webParam: any): Promise<{}> {
    // ls.setLaunchGames({ pkgname: id }, false);
    return Market.__asyncCallApi('GameMan19.InstallGame', { id, webParam });
  },
  // 卸载端游
  RemoveGame(id: string): Promise<{}> {
    // ls.setLaunchGames({ pkgname: id }, true);
    return Market.__asyncCallApi('GameMan19.RemoveGame', { id });
  },
  // 启动端游
  LaunchGame(id: string): Promise<{}> {
    // ls.setLaunchGames({ pkgname: id }, false);
    return Market.__asyncCallApi('GameMan19.LaunchGame', { id });
  },
};

export default GameMan19;
